
import Vue from "vue";
import { namespace } from "vuex-class";
import Component from "vue-class-component";
import { moneyFormatter } from "../utils";
import imageService from "@/services/ImageService";
import {
  calcular_preco_quantidade_minima,
  calcular_preco_unidade_medida,
} from "../../services/ProdutosService";

const Auth = namespace("Auth");
const PedidoStore = namespace("Pedido");
const AppConfigStore = namespace("AppConfig");

@Component({
  name: "ProdutoCard",
  props: {
    produto: {} as any,
    width: {
      type: String,
      default: "300px",
    },
  },
  components: {},
})
export default class ProdutoCard extends Vue {
  @AppConfigStore.Getter
  private getConfigEstoque!: any;

  @Auth.Getter
  private isLoggedIn!: boolean;

  @PedidoStore.Getter
  private getPedido!: any;

  get localProduto() {
    return this.$props.produto;
  }

  get pedidoProduto() {
    return this.getPedido?.produtos?.find(
      (el) => el.produto.id === this.localProduto.id
    );
  }

  get valorUnitario() {
    const unidadeMedidaAtual = this.unidadeMedidaSelected;

    const precoUnit = calcular_preco_unidade_medida({
      lista_unidade_medida: this.localProduto.unidadesMedida,
      preco_unit:
        +this.localProduto.promocao?.[0]?.precoUnit ||
        +this.localProduto.precosVenda?.[0]?.precoUnit,
      unidadeMedidaPadrao: this.localProduto.unidadeMedida,
      unidadeMedida: unidadeMedidaAtual,
    });

    return moneyFormatter(precoUnit);
  }

  get quantidadePedido() {
    return this.pedidoProduto?.quantidade || 0;
  }

  get porcentagemPromocao() {
    const promocao = this.localProduto?.promocao;

    if (!promocao?.length) return 0;

    const valor_unit_promocao = promocao[0].precoUnit;
    const valor_unit_padrao = this.localProduto?.precosVenda?.[0]?.precoUnit;

    const porcentagem_desconto =
      100 - (+valor_unit_promocao * 100) / +valor_unit_padrao;

    if (porcentagem_desconto < 1) return 0;

    return Math.floor(porcentagem_desconto);
  }

  get valorUnitarioPadrao() {
    const unidadeMedidaAtual = this.unidadeMedidaSelected;

    const preco_unit = calcular_preco_unidade_medida({
      lista_unidade_medida: this.localProduto.unidadesMedida,
      preco_unit: +this.localProduto.precosVenda?.[0]?.precoUnit,
      unidadeMedidaPadrao: this.localProduto.unidadeMedida,
      unidadeMedida: unidadeMedidaAtual,
    });

    return moneyFormatter(preco_unit);
  }

  get unidadeMedidaSelected() {
    const validUnidades: any[] = this.localProduto.unidadesMedida?.filter(
      (un: any) => un.situacao != "I"
    );

    const unPadraoFator = validUnidades?.find(
      (un: any) => un.id == this.localProduto.unidadeMedida
    )?.id;
    // primeira unidade em ordem alfabética decrescente
    const primeiraUn = validUnidades?.reduce(
      (prev: any, current: any) => (prev.id > current.id ? prev : current),
      0
    )?.id;

    const unPadrao = this.localProduto.unidadeMedida;

    const unidadeMedidaAtual = unPadraoFator || primeiraUn || unPadrao;

    return unidadeMedidaAtual;
  }

  isProdutoNoPedido() {
    return true;
  }

  buildProdutoImage() {
    const imgs = imageService.getProdutoImages(this.$props.produto)[0];
    const result = {
      src: imgs.img,
      "lazy-src": imgs.thumb,
    };
    return result;
  }
}
